import { render } from "./OptionFilter.vue?vue&type=template&id=2ea47e04"
import script from "./OptionFilter.vue?vue&type=script&lang=js"
export * from "./OptionFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__